import React from "react";
import { Link } from "react-router-dom";
import "./PricingCard.css";

const PricingCard = ({
  plan,
  isCurrentPlan,
  onAction,
  isLoading,
  actionDisabled,
}) => {
  const isFree = plan === "Free";

  return (
    <div className={`plan-card ${isCurrentPlan ? "current" : ""}`}>
      {isCurrentPlan && <div className="current-badge">Current Plan</div>}
      <h3>{plan} Plan</h3>
      <div className="plan-price">
        ${isFree ? "0" : "20"}
        <span className="price-period">/ year</span>
      </div>
      <ul className="plan-features">
        {isFree ? (
          <>
            <li>Up to 3 transaction summaries per year</li>
            <li>Access to Coin Basis Portfolio</li>
            <li>Standard Email Support </li>
            <li className="excluded">Downloadable Tax Summary Forms</li>
          </>
        ) : (
          <>
            <li>Unlimited transactions</li>
            <li>Access to Coin Basis Portfolio</li>
            <li>Priority Email Support</li>
            <li>Downloadable Tax Summary Forms</li>
            <li>Early access to new features</li>
          </>
        )}
      </ul>
      <Link to="/account?section=membership" className="upgrade-button">
        {isLoading ? "Processing..." : `Learn More`}
      </Link>
    </div>
  );
};

export default PricingCard;
